import { Paper, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { BarChart } from "@mui/x-charts/BarChart";
import BarItemTooltip from "../BarItemTooltip";
import { formatDisplayDate, formatInteger } from "../formatters";
import { PerformanceRow } from "./performanceApiMapping";

interface PerformanceChartsProps {
  rows: PerformanceRow[];
}

export default function PerformanceCharts({ rows }: PerformanceChartsProps) {
  const chronological = [...rows].sort((a, b) => (a.date < b.date ? -1 : 1));
  const dates = chronological.map((row) => formatDisplayDate(row.date));

  return (
    <Grid container spacing={2.5}>
      <Grid size={{ xs: 12, md: 6 }}>
        <Paper variant="outlined" sx={{ p: "18px 20px", borderColor: "#ececec" }}>
          <Typography variant="subtitle2" sx={{ mb: 1 }}>
            Impressions - by day
          </Typography>
          <BarChart
            height={270}
            xAxis={[{ scaleType: "band", data: dates }]}
            series={[
              {
                data: chronological.map((row) => row.impressions),
                color: "#8E24AA",
                valueFormatter: (value) => (value === null ? "" : formatInteger(value)),
              },
            ]}
            tooltip={{ trigger: "none" }}
          >
            <BarItemTooltip />
          </BarChart>
        </Paper>
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <Paper variant="outlined" sx={{ p: "18px 20px", borderColor: "#ececec" }}>
          <Typography variant="subtitle2" sx={{ mb: 1 }}>
            Leads - by day
          </Typography>
          <BarChart
            height={270}
            xAxis={[{ scaleType: "band", data: dates }]}
            series={[
              {
                data: chronological.map((row) => row.leads),
                color: "#5B9BD5",
                valueFormatter: (value) => (value === null ? "" : formatInteger(value)),
              },
            ]}
            tooltip={{ trigger: "none" }}
          >
            <BarItemTooltip />
          </BarChart>
        </Paper>
      </Grid>
    </Grid>
  );
}
